import { render, staticRenderFns } from "./CommentQuestion.vue?vue&type=template&id=0bc93a74&"
import script from "./CommentQuestion.vue?vue&type=script&lang=ts&"
export * from "./CommentQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports